document.addEventListener('DOMContentLoaded', function () {
    const animationDurationMs = 300;

    /* ========================================
       Slide Animation Helpers
       ======================================== */
    
    function slideUp(element) {
        element.style.overflow = 'hidden';
        element.style.height = element.scrollHeight + 'px';
        element.offsetHeight; // Force browser reflow to trigger animation
        element.style.transition = `height ${animationDurationMs}ms ease`;
        element.style.height = '0';
    }

    function slideDown(element) {
        element.style.display = 'block';
        element.style.overflow = 'hidden';
        const targetHeight = element.scrollHeight + 'px';

        element.style.height = '0';
        element.offsetHeight; // Force browser reflow to trigger animation
        element.style.transition = `height ${animationDurationMs}ms ease`;
        element.style.height = targetHeight;
    }

    /* ========================================
       Initialize: Open First Accordion on Load
       ======================================== */
    
    const firstAccordionItem = document.querySelector('.single-accord:first-of-type');

    if (firstAccordionItem) {
        const firstBodyContainer = firstAccordionItem.querySelector('.body-container');
        const firstAccordionHeader = firstAccordionItem.querySelector('.accordion');
        const firstChevronIcon = firstAccordionItem.querySelector('span');

        firstBodyContainer.classList.add('current');
        firstAccordionHeader.classList.add('change-color');
        firstChevronIcon.classList.add('rotate-icon');

        firstBodyContainer.style.display = 'block';
    }

    /* ========================================
       Accordion Click Event Handler
       ======================================== */
    
    document.querySelectorAll('.single-accord .header-container').forEach(headerElement => {
        headerElement.addEventListener('click', function () {
            const parentAccordionItem = this.parentElement.parentElement;
            const bodyContainerElement = this.nextElementSibling;

            // this.parentElementscrollIntoView({behavior: 'smooth', block: 'start'});

            if (bodyContainerElement.classList.contains('current')) {
                // Close the currently open accordion
                this.querySelector('span')?.classList.remove('rotate-icon');
                this.querySelector('.accordion')?.classList.remove('change-color');

                bodyContainerElement.classList.remove('current');
                slideUp(bodyContainerElement);
            } else {
                // Open the selected accordion
                bodyContainerElement.classList.add('current');
                slideDown(bodyContainerElement);

                this.querySelector('span')?.classList.add('rotate-icon');
                this.querySelector('.accordion')?.classList.add('change-color');
            }
        });
    });
});
